module.exports = __webpack_public_path__ + "static/media/mail.5fa86db8.svg";